import React from 'react';
import PropTypes from 'prop-types';

function IconBackward({ color = '#B3B3B3', size = 20, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 5L6 10L12 15" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  )
}

IconBackward.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconBackward;
